<template>
  <section class="developer-status">
    <!--头部开始-->
    <header class="head">
      <i class="icon-notice"></i>
    </header>
    <!--头部结束-->

    <h3 class="apply-result">审核中</h3>

    <p class="apply-desc">等待审核中，请加入官方开发者审核QQ群，联系管理员通过审核。(进群请务必查看置顶公告)</p>
    <p class="qq-group">审核1群：546241346</p>
    <!--<p class="qq-group qq-group-bottom">审核2群：549966296</p>-->

    <!--操作开始-->
    <div class="handle">
      <router-link class="item go-home" to="/home">返回开发者首页</router-link>
    </div>
    <!--操作结束-->
  </section>
</template>

<script type="text/ecmascript-6">
  export default {
    // 审核通过页面
    name: 'developerStatus',
    methods: {
      goHomeFn () {
        this.$router.push({path: 'home'})
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "developerStatus.styl";
</style>



// WEBPACK FOOTER //
// src/views/developerStatus/developerStatus.vue